import { isNumberHaveValue } from 'aa_common/front-end/helpers'
import { DEPRECIATION_METHOD_CODE, LEDGER_PURPOSE } from 'common/constants'
import { AssetLedger, LedgerSetting, LedgerSettingsItem } from 'common/models'

export const isAccountingJournalTarget = (ledger?: LedgerSettingsItem | LedgerSetting) => {
  return [LEDGER_PURPOSE.ACCOUNTING, LEDGER_PURPOSE.TAX_AND_ACCOUNTING].includes(ledger?.ledger_purpose as any)
}

export const isAccountingJournalOnly = (ledger?: LedgerSettingsItem | LedgerSetting) => {
  return [LEDGER_PURPOSE.ACCOUNTING].includes(ledger?.ledger_purpose as any)
}

export const isTaxJournalTarget = (ledger?: LedgerSettingsItem | LedgerSetting) => {
  return [LEDGER_PURPOSE.TAX].includes(ledger?.ledger_purpose as any)
}

export function findAccountingLedger(ledgers?: LedgerSettingsItem[]) {
  return (ledgers || []).find(isAccountingJournalTarget)
}

export function getAccountingLedger(ledgers?: AssetLedger[]) {
  return (ledgers || []).find(({ ledger_setting }) => isAccountingJournalTarget(ledger_setting))
}

export function isHaveBothTwoLedgers(ledgers?: LedgerSetting[]) {
  return (
    ledgers?.some((ledger: LedgerSetting) => isAccountingJournalTarget(ledger)) &&
    ledgers?.some((ledger: LedgerSetting) => isTaxJournalTarget(ledger))
  )
}

export function getDMethod(ledger?: AssetLedger | null, enablePartialImpair?: boolean) {
  return enablePartialImpair && ledger?.original_depreciation_method_code
    ? ledger.original_depreciation_method_code
    : ledger?.depreciation_method_code
}

export function getServiceLife(ledger?: AssetLedger | null, enablePartialImpair?: boolean) {
  return enablePartialImpair && isNumberHaveValue(ledger?.original_service_life)
    ? ledger?.original_service_life
    : ledger?.service_life
}

export function isPartialImpairment(ledger?: AssetLedger) {
  const currentDMethod = ledger?.depreciation_method_code
  return Boolean(
    currentDMethod &&
      [
        DEPRECIATION_METHOD_CODE.DepreciationMethodAfterImpairmentStraightLine,
        DEPRECIATION_METHOD_CODE.DECLINING_BALANCE_AFTER_IMPAIR,
      ].includes(currentDMethod)
  )
}
